import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Select, Spin,
} from 'antd';
import Flex from '../../../shared/components/basic/Flex';
import { Text } from '../../../shared/components';
import ShowIf from '../../../shared/components/dataDisplay/ShowIf';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
export default function ColoracionBar({
  handleChangeColoracion,
  colores,
  lentesGamasColores,
  loadingColores,
  trabajaConColores,
  modo,
}) {
  const drawColorOptions = (colores) => {
    if (loadingColores) return <Flex mx={16} alignItems="baseline"><Spin indicator={antIcon} /></Flex>;
    let selectOptions = [];
    const lenteGamaSinColor = lentesGamasColores.find(e => (e.tipo_id === 1));
    const lentesGamasColoresGrouped = lentesGamasColores.filter(e => e.tipo_id !== 1);
    if (modo === 'consulta') {
      const selectSinColor = colores.find(e => lenteGamaSinColor.id === e.gamaColor);
      let selectGroupedOptions = [];
      if (trabajaConColores) {
        selectGroupedOptions = lentesGamasColoresGrouped.map((lenteGamaColor) => {
          const coloresGama = colores.filter(color => (color.nombre !== 'Ninguno' && color.gamaColor === lenteGamaColor.id));
          return (
            <Select.OptGroup label={lenteGamaColor.gama_color}>
              {coloresGama.map(({ id, nombre }) => (
                <Select.Option key={id} value={id}>{nombre}</Select.Option>
              ))}
            </Select.OptGroup>
          );
        });
      } else {
        selectGroupedOptions = lentesGamasColoresGrouped.map((lenteGamaColor) => {
          const colorGama = colores.find(color => (color.nombre === 'Ninguno' && color.gamaColor === lenteGamaColor.id));
          if (!colorGama) return;
          return (
            <Select.Option key={colorGama.id} value={colorGama.id}>{lenteGamaColor.gama_color}</Select.Option>
          );
        });
      }
      const selectSinColorOption = (selectSinColor) ? <Select.Option key={selectSinColor.id} value={selectSinColor.id}>{selectSinColor.nombre}</Select.Option> : '';
      selectOptions.push(selectSinColorOption);
      selectOptions = selectOptions.concat(selectGroupedOptions);
    } else {
      selectOptions = colores.map(
        color => <Select.Option key={color.id} value={color.id}>{color.nombre}</Select.Option>,
      );
    }
    if ((modo === 'consulta' && (!colores || colores.length === 0))) {
      return <div />;
    }
    const colorsinColor = colores.find(e => lenteGamaSinColor.id === e.gamaColor);
    return (
      <Select
        showSearch
        defaultValue={modo === 'consulta' && colorsinColor ? colorsinColor.id : undefined}
        placeholder="Sel. color"
        optionFilterProp="children"
        onChange={e => handleChangeColoracion(e)}
        filterOption={(input, option) => {
          let opt = option.props.children;
          if (Array.isArray(opt)) {
            opt = opt.find(c => c.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0);
            if (opt) {
              return true;
            }
            return false;
          }
          return opt.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
        style={{ width: 132 }}
        loading={loadingColores}
      >
        {selectOptions}
      </Select>
    );
  };
  return (
    <ShowIf condition={modo === 'consulta' || trabajaConColores}>
      <Flex alignItems="baseline">
        <Text mr={16}>Coloración: </Text>
        {drawColorOptions(colores)}
      </Flex>
    </ShowIf>
  );
}

ColoracionBar.propTypes = {
  handleChangeColoracion: PropTypes.func,
  colores: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    empresaId: PropTypes.number,
    esCliente: PropTypes.number,
    nombre: PropTypes.string,
    gamaColor: PropTypes.number,
    activa: PropTypes.number,
    fechaModificacion: PropTypes.string,
  })).isRequired,
  lentesGamasColores: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    gama_color: PropTypes.string,
  })),
  loadingColores: PropTypes.bool,
  trabajaConColores: PropTypes.bool,
  modo: PropTypes.string,
};
ColoracionBar.defaultProps = {
  handleChangeColoracion: () => {},
  loadingColores: false,
  trabajaConColores: false,
  lentesGamasColores: [],
  modo: 'consulta',
};
